import { useEffect, useState } from "react";
import { countdown } from "../../lib/format";

export const Countdown = ({ seconds, className = "", testId }) => {
  const [left, setLeft] = useState(seconds ?? 0);
  useEffect(() => { setLeft(seconds ?? 0); }, [seconds]);
  useEffect(() => {
    const t = setInterval(() => setLeft((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, []);
  const urgent = left > 0 && left < 3600 * 6;
  return <span className={`mono ${urgent ? "text-warn" : ""} ${className}`} data-testid={testId}>{countdown(left)}</span>;
};
